/* tslint:disable */
/* eslint-disable */
/**
 * ${api_name}
 * The Ciptex Conference Control API allows you to interact with Ciptex Conferences and control realtime actions
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SyncObjectNames interface.
 */
export function instanceOfSyncObjectNames(value) {
    if (!('speakersMap' in value) || value['speakersMap'] === undefined)
        return false;
    if (!('viewersMap' in value) || value['viewersMap'] === undefined)
        return false;
    if (!('specialMap' in value) || value['specialMap'] === undefined)
        return false;
    if (!('streamDocument' in value) || value['streamDocument'] === undefined)
        return false;
    if (!('conferenceSettingsDocument' in value) || value['conferenceSettingsDocument'] === undefined)
        return false;
    return true;
}
export function SyncObjectNamesFromJSON(json) {
    return SyncObjectNamesFromJSONTyped(json, false);
}
export function SyncObjectNamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'speakersMap': json['speakersMap'],
        'viewersMap': json['viewersMap'],
        'specialMap': json['specialMap'],
        'streamDocument': json['streamDocument'],
        'conferenceSettingsDocument': json['conferenceSettingsDocument'],
    };
}
export function SyncObjectNamesToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'speakersMap': value['speakersMap'],
        'viewersMap': value['viewersMap'],
        'specialMap': value['specialMap'],
        'streamDocument': value['streamDocument'],
        'conferenceSettingsDocument': value['conferenceSettingsDocument'],
    };
}
